import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import {
    cloudProcessOne,
    cloudProcessTwo,
    cloudProcessThree,
    cloudProcessFour,
    cloudProcessFive,
    cloudProcessSix,
} from "../../../app-constants";


function Process() {
  return (
    <section className='cloud__process p-100'>
        <Container>
            <Row className='justify-content-center'>
                {/* <Col
                xs={12}
                md={8}
                lg={8}
                xl={8}
                xxl={8}
                >
                    <div className='main-title text-center'>
                        <h2>Cloud Support and Maintenance Process at TekRevol</h2>
                        <p>Take an insider look at how TekRevol has been managing and maintaining the cloud infrastructures to meet the highest levels of security, compliance and operational regulations set out by businesses.</p>
                    </div>
                </Col> */}
                <Col
                    xs={12}
                    md={8}
                    lg={8}
                    xl={8}
                    xxl={8}
                    className="">
                    <div className="example text-center" data-text="">
                        <h2>Cloud Support and Maintenance Process at TekRevol</h2>
                        <p>Take an insider look at how TekRevol has been managing and maintaining the cloud infrastructures to meet the highest levels of security, compliance and operational regulations set out by businesses.</p>
                    </div>
                </Col>
            </Row>
            <Row className='justify-content-center'>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner tekrevol_gray_bg text-center'>
                            <div className="img">{cloudProcessOne}</div>
                            <h2 className='title'>Onboarding</h2>
                            <p>The partner onboarding manager collects data about your cloud environment, services you have deployed and connected ERP infrastructures in your organization. We then perform preliminary security evaluation and review existing documentation to understand the baseline of your cloud environment. While this is the initial stage, we set up communication channels and understand the expectations of the key internal stakeholders of your cloud infrastructure.</p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner tekrevol_gray_bg text-center'>
                            <div className="img">{cloudProcessTwo}</div>
                            <h2 className='title'>Planning</h2>
                            <p>This is our key strategy phase where we build an action plan and configure tools to track KPIs and measure performance. We list major resources we plan to utilize, understand the security state of your organization, and establish response protocols to identify issues, handle incidents and resolutions. </p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner tekrevol_gray_bg text-center'>
                            <div className="img">{cloudProcessThree}</div>
                            <h2 className='title'>Support Implementation </h2>
                            <p>We continuously monitor cloud performance in real-time, gather data, analyze, optimize and address potential incidents that may or may not impact operations. During support and maintenance, we are laser-focused on keeping the cloud running smoothly, minimizing downtime, and assessing the response protocols. </p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-xl-0 mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner tekrevol_gray_bg text-center'>
                            <div className="img">{cloudProcessFour}</div>
                            <h2 className='title'>Evaluation and Control </h2>
                            <p>This is our major maintenance step that runs simultaneously with our support implementation plans. Our team members analyze key data, then allocate resources for improving cloud performance, optimizing cloud usage costs and scaling better than legacy infrastructure. We also periodically review the cloud for vulnerabilities and measure real data against security standards. </p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-md-0 mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner tekrevol_gray_bg text-center'>
                            <div className="img">{cloudProcessFive}</div>
                            <h2 className='title'>Reporting</h2>
                            <p>We document the complete cloud support process to the dot and provide regular insights on cloud performance, issues and action items. The project managers simultaneously prepare recommendation reports for performance and efficiency. </p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-0"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner tekrevol_gray_bg text-center'>
                            <div className="img">{cloudProcessSix}</div>
                            <h2 className='title'>Compliance</h2>
                            <p>Our cloud solutions are developed with strong APIs and integration characteristics which allow for smooth interaction with other applications and services.</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default Process